/* eslint-disable @next/next/no-img-element */
"use client";
import React from "react";
import "../../../Home/ClientSlider/ClientSlider.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from "next/image";
import ReactStars from "react-stars";
import FounderImageFirst1 from "../../../../../public/assets/General-Img/About/career/FounderImageFirst1.webp";
import FounderImageSecond from "../../../../../public/assets/General-Img/About/career/FounderImageSecond.webp";
import StraightQuotes from "../../../../../public/assets/General-Img/About/career/StraightQuotes.webp";

export const dynamic = "force-dynamic";

const CareerClientSlider = () => {
    var settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const ClientSliderData = {
        title: "Employee Reviews",
        subtitle: "",
        discription: "Don't just take our word for it. Hear what our employees have to say about working at Tanθ",
        services: [
            {
                id: 1,
                clientImage: FounderImageFirst1,
                alt: "client reviews",
                clientDescription: "Working at Tanθ has been an incredible journey. The projects are challenging and rewarding, and the team is supportive and collaborative. I've grown so much as a blockchain developer here.",
                clientName: "Manav Patel",
                clientPosition: "Blockchain Developer",
                rating: 5.0,
            },
            {
                id: 2,
                clientImage: FounderImageSecond,
                alt: "client reviews",
                clientDescription: "The culture at Tanθ is truly inclusive and empowering. I've had the opportunity to work on some amazing projects and learn from some of the best in the industry. It's a fantastic place to work.",
                clientName: "Dhara Patel",
                clientPosition: "Human Resource Manager",
                rating: 4.8,
            },
            {
                id: 3,
                clientImage: FounderImageFirst1,
                alt: "client reviews",
                clientDescription: "I love the flexibility and the emphasis on work-life balance. The leadership team genuinely cares about our well-being and professional growth. It's a great environment to innovate and excel.",
                clientName: "Payal Parsana",
                clientPosition: "Project Manager",
                rating: 5.0,
            },
            {
                id: 4,
                clientImage: FounderImageSecond,
                alt: "client reviews",
                clientDescription: "Joining Tanθ was one of the best career decisions I've made for my career. The opportunities for growth and the supportive team environment make it an exceptional place to work.",
                clientName: "Sanjay ",
                clientPosition: "Marketing Specialist",
                rating: 4.5,
            },
        ],
    };

    return (
        <>
            <section className="container mx-auto my-20 lg:my-[140px] px-4 md:px-24 lg:px-24 xl:px-0">
                <h2 className="text-2xl md:text-3xl xl:text-4xl font-bold pb-4 text-center font-manrope">
                    {ClientSliderData?.title}
                </h2>

                {ClientSliderData?.subtitle && (
                    <h2 className="text-2xl md:text-3xl xl:text-4xl font-bold pb-7 text-center font-manrope">
                        {ClientSliderData?.subtitle}
                    </h2>
                )}

                {ClientSliderData?.discription && (
                    <h3 className="text-center text-[#59587C] font-normal lg:pb-8 2xl:px-72 2xl:mx-20 xl:px-60 xl:mx-10">
                        {ClientSliderData?.discription}
                    </h3>
                )}

                <Slider {...settings} className="z-0">
                    {ClientSliderData?.services?.map((element, ind) => {
                        return (
                            <div
                                className="grid grid-cols-1 lg:grid-cols-3 mt-14 mb-10 client-details"
                                key={element.id || ind}
                            >
                                <div className="m-auto mb-10 lg:mb-0">
                                    <Image src={element?.clientImage} alt={element?.clientName} className="w-40 md:w-52 lg:w-80" />
                                </div>
                                <div className="col-span-2 px-4 md:px-14 xl:px-28 my-auto">
                                    <div className="pb-5">
                                        <div className="flex justify-start gap-5">
                                            <Image src={StraightQuotes} alt="Straight Quotes" className="w-5 lg:w-10" />
                                            <ReactStars
                                                count={5}
                                                value={element?.rating}
                                                edit={false}
                                                size={32}
                                                color2={"#410EAD"}
                                            />
                                        </div>
                                        <p className="text-sm lg:text-lg text-center text-[#59587C] font-normal py-5 client-slider-subtitle px-3 2xl:px-24">
                                            {element.clientDescription}
                                        </p>
                                        <div className="flex justify-end">
                                            <Image src={StraightQuotes} alt="Straight Quotes" className="w-5 lg:w-10" />
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <h3 className="text-lg lg:text-xl font-bold tracking-wide font-manrope">
                                            {element.clientName}
                                        </h3>
                                        <h4 className="text-xs lg:text-sm tracking-wide text-[#410EAD] font-manrope">
                                            {element.clientPosition}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </Slider>
            </section>
        </>
    );
};

export default CareerClientSlider;
